import type { AbstractTailoredWidgetTemplateEditor } from '@/components/template-widgets/AbstractTailoredWidgetEditorTemplate.class';
import { TemplateWidgetBusinessIndicatorAdvancementEditorComponent } from '@/features/business-indicators/widgets/template-widget-business-indicator-advancement-editor/template-widget-business-indicator-advancement-editor.component';
import { TemplateWidgetBusinessIndicatorAdvancementComponent } from '@/features/business-indicators/widgets/template-widget-business-indicator-advancement/template-widget-business-indicator-advancement.component';
import { TemplateWidgetBusinessIndicatorGaugeEditorComponent } from '@/features/business-indicators/widgets/template-widget-business-indicator-gauge-editor/template-widget-business-indicator-gauge-editor.component';
import { TemplateWidgetBusinessIndicatorGaugeComponent } from '@/features/business-indicators/widgets/template-widget-business-indicator-gauge/template-widget-business-indicator-gauge.component';
import { Injectable, type Type } from '@angular/core';
import { TailoredWidgetTemplateCode } from '../../interfaces/TailoredWidget.interface';
import type { AbstractTailoredTemplateWidget } from './AbstractTailoredWidgetTemplate.class';
import { TemplateWidgetCustomImageBase64EditorComponent } from './template-widget-custom-image-base64-editor/template-widget-custom-image-base64-editor.component';
import { TemplateWidgetCustomImageBase64Component } from './template-widget-custom-image-base64/template-widget-custom-image-base64';
import { TemplateWidgetCustomImageComponent } from './template-widget-custom-image/template-widget-custom-image';
import { TemplateWidgetHtmlContentEditorComponent } from './template-widget-html-content-editor/template-widget-html-content-editor.component';
import { TemplateWidgetHtmlContentComponent } from './template-widget-html-content/template-widget-html-content';
import { TemplateWidgetSectionTitleComponent } from './template-widget-section-title/template-widget-section-title';

@Injectable({
    providedIn: 'root'
})
export class TemplateWidgetClassStaticProvider {
    static getWidgetFromTailoredWidgetTemplateCode(code: TailoredWidgetTemplateCode): Type<AbstractTailoredTemplateWidget<any>> {
        switch (code) {
            case TailoredWidgetTemplateCode.SECTION_TITLE: {
                return TemplateWidgetSectionTitleComponent;
            }
            case TailoredWidgetTemplateCode.CUSTOM_IMAGE: {
                return TemplateWidgetCustomImageComponent;
            }
            case TailoredWidgetTemplateCode.CUSTOM_IMAGE_BASE64: {
                return TemplateWidgetCustomImageBase64Component;
            }
            case TailoredWidgetTemplateCode.HTML_CONTENT: {
                return TemplateWidgetHtmlContentComponent;
            }
            case TailoredWidgetTemplateCode.BUSINESS_INDICATOR_GAUGE: {
                return TemplateWidgetBusinessIndicatorGaugeComponent;
            }
            case TailoredWidgetTemplateCode.BUSINESS_INDICATOR_ADVANCEMENT: {
                return TemplateWidgetBusinessIndicatorAdvancementComponent;
            }
        }
    }

    static getWidgetEditorFromTailoredWidgetTemplateCode(
        code: TailoredWidgetTemplateCode
    ): Type<AbstractTailoredWidgetTemplateEditor<any>> {
        switch (code) {
            case TailoredWidgetTemplateCode.CUSTOM_IMAGE_BASE64: {
                return TemplateWidgetCustomImageBase64EditorComponent;
            }
            case TailoredWidgetTemplateCode.BUSINESS_INDICATOR_GAUGE: {
                return TemplateWidgetBusinessIndicatorGaugeEditorComponent;
            }
            case TailoredWidgetTemplateCode.HTML_CONTENT: {
                return TemplateWidgetHtmlContentEditorComponent;
            }
            case TailoredWidgetTemplateCode.BUSINESS_INDICATOR_ADVANCEMENT: {
                return TemplateWidgetBusinessIndicatorAdvancementEditorComponent;
            }
            default:
                throw 'not Implemented';
        }
    }
}
